/* Tu Sabor · interacciones del tema */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var TS = window.TS || {};

  function money(cents) {
    var f = TS.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals') return Math.round(v).toString();
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString();
      return v.toFixed(2);
    });
  }
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    $('span', el).textContent = t; el.classList.add('show');
    clearTimeout(toast.k); toast.k = setTimeout(function () { el.classList.remove('show'); }, 2300);
  }

  /* Aparición al hacer scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .08, rootMargin: '0px 0px -30px 0px' });
    $$('.rv').forEach(function (el) { io.observe(el); });
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = +el.getAttribute('data-count'), pre = el.getAttribute('data-pre') || '', t0 = performance.now();
        if (!end) return;
        (function f(t) { var k = Math.min((t - t0) / 1600, 1); el.textContent = pre + Math.round(end * (1 - Math.pow(1 - k, 3))).toLocaleString('es-ES'); if (k < 1) requestAnimationFrame(f); })(t0);
        cio.unobserve(el);
      });
    });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  } else { $$('.rv').forEach(function (el) { el.classList.add('in'); }); }

  /* Preguntas frecuentes con animación */
  $$('.faq details').forEach(function (d) {
    var s = $('summary', d), a = $('.ans', d);
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) { a.style.height = a.scrollHeight + 'px'; requestAnimationFrame(function () { a.style.height = '0px'; }); setTimeout(function () { d.open = false; a.style.height = ''; }, 360); }
      else { d.open = true; a.style.height = '0px'; requestAnimationFrame(function () { a.style.height = a.scrollHeight + 'px'; }); setTimeout(function () { a.style.height = ''; }, 380); }
    });
  });

  /* Menú móvil */
  var drawer = $('#drawer'), burger = $('#burger');
  function setDrawer(open) { if (!drawer) return; drawer.classList.toggle('open', open); drawer.setAttribute('aria-hidden', !open); if (burger) burger.setAttribute('aria-expanded', open); }
  if (burger) burger.addEventListener('click', function () { setDrawer(true); });
  $$('#drawer [data-close], #drawer a').forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* Cuenta atrás hasta una fecha real */
  var end = TS.offerEnd ? new Date(TS.offerEnd) : null;
  if (end && !isNaN(end)) {
    $$('[data-fecha]').forEach(function (el) { el.textContent = end.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }); });
    var tick = function () {
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      var d = Math.floor(s / 86400); s %= 86400;
      var p = [d, Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60].map(function (v) { return String(v).padStart(2, '0'); });
      $$('[data-reloj]').forEach(function (el) { el.textContent = (+p[0] ? (+p[0]) + 'd ' : '') + p[1] + ':' + p[2] + ':' + p[3]; });
      $$('[data-cd]').forEach(function (c) { $$('span', c).forEach(function (sp, i) { if (sp.firstChild) sp.firstChild.nodeValue = p[i]; }); });
    };
    tick(); setInterval(tick, 1000);
  } else { $$('.reloj,.timer').forEach(function (el) { el.style.display = 'none'; }); }

  /* Barra de compra fija */
  var barra = $('#barra');
  if (barra) {
    var onScroll = function () { barra.classList.toggle('on', scrollY > 700 && (innerHeight + scrollY) < document.body.scrollHeight - 200); };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Añadir varios productos (upsell) */
  function addItems(items) {
    return fetch(TS.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  var upBtn = $('[data-addup]');
  if (upBtn) {
    var refresh = function () {
      var t = +upBtn.getAttribute('data-base');
      $$('[data-up]:checked').forEach(function (u) { t += +u.getAttribute('data-price'); });
      var el = $('[data-total]', upBtn); if (el) el.textContent = money(t);
    };
    $$('[data-up]').forEach(function (c) { c.addEventListener('change', refresh); });
    upBtn.addEventListener('click', function () {
      upBtn.disabled = true;
      var items = [{ id: +upBtn.getAttribute('data-addup'), quantity: 1 }];
      $$('[data-up]:checked').forEach(function (u) { items.push({ id: +u.getAttribute('data-up'), quantity: 1 }); });
      addItems(items).then(function () { location.href = TS.cartUrl; }).catch(function () { upBtn.disabled = false; location.href = TS.cartUrl; });
    });
  }

  /* Carrito: cantidades y sugerencias */
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      fetch(TS.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-qty'), quantity: Math.max(0, +b.getAttribute('data-q')) }) })
        .then(function () { location.reload(); });
    });
  });
  $$('[data-addnow]').forEach(function (c) {
    c.addEventListener('change', function () { if (c.checked) addItems([{ id: +c.getAttribute('data-addnow'), quantity: 1 }]).then(function () { location.reload(); }); });
  });

  /* Filtros del catálogo */
  $$('#filtros button').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('#filtros button').forEach(function (x) { x.classList.toggle('on', x === b); });
      var f = b.getAttribute('data-f');
      $$('#shopgrid .mini').forEach(function (c) { c.style.display = (f === 'all' || c.getAttribute('data-cat') === f) ? '' : 'none'; });
    });
  });

  /* Aviso al volver del carrito */
  if (/[?&]added=1/.test(location.search)) toast(TS.added || 'OK');
})();
